import React from 'react'
import BaseEmptyState from 'components/Shared/EmptyState'
import { theme } from 'theme'
import { useNewTranslation } from 'hooks'
import Icon from 'components/Icon/Icon'
import EmptyAmbassadorImage from 'icons/EmptyTable.png'
import { AmbassadorBrand } from 'services/api/ambassadors'
import { PLATFORM_CONTENT_TYPE_ENUM } from 'services/api/constants'

interface EmptyStateProps {
    brandList?: AmbassadorBrand[]
    contentType: PLATFORM_CONTENT_TYPE_ENUM | null
}

export const EmptyState: React.FC<EmptyStateProps> = ({ brandList, contentType }) => {
    const [t] = useNewTranslation()
    let title = t('manageAmbassandor.emptyStateTitle')
    let body = t('manageAmbassandor.emptyStateSubtitle')
    let customIcon = <img src={EmptyAmbassadorImage} />

    if (brandList?.length === 0) {
        title = t('manageAmbassandor.brandList.emptyBrandListTitle')
        body = t('manageAmbassandor.brandList.emptyBrandListSubtext')
        customIcon = <Icon.NotFoundIcon width="293px" height="235px" />
    }

    if (contentType) {
        title = t('emptyState.cantFindTitle')
        body = t('emptyState.noSearchResultSubmissionSubtitle')
        customIcon = <Icon.NotFoundIcon width="293px" height="235px" />
    }
    return (
        <BaseEmptyState
            my={theme.spacing.l}
            title={title}
            titleColor="primary"
            body={body}
            bodyColor="secondary"
            dataTestId="empty-brand-ambassador"
            customIcon={customIcon}
        />
    )
}
